import { render, staticRenderFns } from "./BillDetDataAkumActivityIndex.vue?vue&type=template&id=24201dee&scoped=true&"
import script from "./BillDetDataAkumActivityIndex.vue?vue&type=script&lang=js&"
export * from "./BillDetDataAkumActivityIndex.vue?vue&type=script&lang=js&"
import style0 from "./BillDetDataAkumActivityIndex.vue?vue&type=style&index=0&id=24201dee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24201dee",
  null
  
)

export default component.exports